export const ERROR_MESSAGE_BOARD_IS_LOCATIONLESS = 'Board is locationless';
